import * as angular from "angular";
import userForm from "../../user-form/user-form";
import template from "./user-modal-profile-tab.html";
import type { ModalTabItem } from "../../../modals/tabbed-modal/tabbed-modal-types";

export interface UserModalProfileTabController {
	user?: unknown;
	permissions?: unknown;
	reload?: () => unknown;
	setUser?: (locals: { user: unknown }) => unknown;
}

// eslint-disable-next-line no-redeclare
export class UserModalProfileTabController {
	public readonly tab: ModalTabItem = {
		name: "Profile",
		code: "PROFILE"
	};
}

export default angular
	.module("vesl.components.user-modal.tabs.profile", [userForm])
	.component("userModalProfileTab", {
		controller: UserModalProfileTabController,
		template,
		bindings: {
			user: "<",
			reload: "&",
			setUser: "&",
			permissions: "<"
		}
	})
	.name;
